var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoadmap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-0.5 -0.5 16 16",
    height: 16,
    width: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-roadmap"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 994",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M0.9375 2.5h2.1875m7.8125 5a2.5 2.5 0 1 0 0 -5H6.25m-2.1875 10a2.5 2.5 0 1 1 0 -5h3.75m-0.625 5h3.75",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 437",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.125 2.5a1.5625 1.5625 0 1 0 3.125 0 1.5625 1.5625 0 1 0 -3.125 0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 439",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.0625 12.5a1.5625 1.5625 0 1 0 3.125 0 1.5625 1.5625 0 1 0 -3.125 0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 438",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.8125 7.5a1.5625 1.5625 0 1 0 3.125 0 1.5625 1.5625 0 1 0 -3.125 0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 128",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.0215625 13.877500000000001c0.025 0.15437499999999998 0.17343750000000002 0.2271875 0.31781249999999994 0.16718750000000002 0.2553125 -0.10562500000000001 0.7103125 -0.3115625 1.3996875 -0.6837500000000001 0.46156250000000004 -0.249375 0.765625 -0.44875 0.9640625 -0.59875 0.24781250000000002 -0.18687499999999999 0.248125 -0.49062500000000003 0 -0.6778125 -0.1984375 -0.15 -0.5025000000000001 -0.34937500000000005 -0.9640625 -0.5984375 -0.689375 -0.37187499999999996 -1.144375 -0.578125 -1.3996875 -0.6837500000000001 -0.144375 -0.06 -0.29250000000000004 0.012812500000000001 -0.31781249999999994 0.16718750000000002 -0.04 0.2425 -0.08406250000000001 0.684375 -0.08406250000000001 1.4540624999999998 0 0.7696875000000001 0.0440625 1.2115624999999999 0.08406250000000001 1.4540624999999998Z",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadmap);
export default __webpack_public_path__ + "static/media/roadmap.a99366c359770d7c7545a674258fcc57.svg";
export { ForwardRef as ReactComponent };